import FAQBlockPreview from "./FAQBlockPreview";

export default FAQBlockPreview;